import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Checkbox from '../../form/Checkbox'

const LMXSettingsModal = ({ store }) => {
    if (!store.lmxSettingsModalVisible || !store.activeChart) return null

    const chart = store.activeChart
    const years = store.questionYearsForChart || []
    const benchmarks = store.getQuestionBenchmarks(chart.questionId, chart.surveyId)

    return (
        <Modal
            show={store.lmxSettingsModalVisible}
            onClose={store.handleCloseLMXSettingsModal}
        >
            <Typography type="h3">LMX chart settings</Typography>

            <br />

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 40 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '50%' }}>
                    <Typography type="b">{i18n.t('powerpoint.labels.comparisonSurveyIds')}</Typography>
                    {years.length ? years.map((y) => (
                        <Checkbox
                            key={y}
                            label={`${y}`}
                            value={y}
                            checked={chart.comparisonYears?.includes(y)}
                            onBlur={() => store.handleToggleComparison(y)}
                        />
                    )) : <Typography type="tiny">No comparison years available</Typography>}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 5, width: '50%' }}>
                    <Typography type="b">{i18n.t('dashboard.benchmarksTitle')}</Typography>
                    {benchmarks.length ? benchmarks.map((b) => (
                        <Checkbox
                            key={b.value}
                            label={b.label}
                            value={b.value}
                            checked={chart.benchmark?.includes(b.value)}
                            onBlur={() => store.handleToggleBenchmark(b.value)}
                        />
                    )) : <Typography type="tiny">No benchmarks available</Typography>}
                </div>
            </div>

            <ModalFooter>
                <Button
                    label={i18n.t('save')}
                    icon="fal fa-save"
                    cssClass="regular primary"
                    onClick={store.handleCloseLMXSettingsModal}
                />
            </ModalFooter>
        </Modal>
    )
}

export default observer(LMXSettingsModal)
